<button
  [appEmmaTooltip]="request.filename"
  [ngClass]="{'selected': isSelected(), 'highlighted': highlighted && request.id === highlighted.id}"
  (click)="triggerClick()"
  mat-button class="request-item">
  <mat-checkbox [disableRipple]="true" class="checkbox-position" (click)="changeSelection($event)" [checked]="isSelected()"></mat-checkbox>
  <mat-icon class="exe">insert_drive_file</mat-icon>
  <span class="title">{{ request.filename }}</span>
</button>
